import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Nigerian() {
  return (
    <ApiCommunityDirectoryPage
      community="Nigerian"
      eyebrow="Nigerian community guide"
      title="Nigerian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Nigerian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Nigerian community guide?"
      modalIdPrefix="nigerian-directory"
    />
  );
}
